import React from "react"
import ReactDOM from "react-dom"
import {ThemeProvider, Theme, Direction} from "@mui/material/styles"
import {nextMaterialUITheme} from "@next/themes"
import ConnectedProductSummary from "./compositions"
import {IS_BROWSER} from "./utils/window"
import {AXE_CONFIGURATION} from "./config/constants"
import {FeatureSettingsContext} from "./contexts/FeatureSettingsContext"

interface AppProps {
    isConfError: boolean
    itemNumber?: string
    appScope?: string
    themeColours?: Theme
    realm: string
    textAlignment: Direction
    themeVersion: string
    enablingCenteredContent: boolean
    launchDarklySettings: any
}

export const App: React.FC<AppProps> & any = (props: AppProps) => {
    if (process.env.NODE_ENV !== "production" && IS_BROWSER()) {
        const config = {
            rules: AXE_CONFIGURATION.rules,
            disableDeduplicate: true,
        }

        const setupAxe = async () => {
            const axe = await import("@axe-core/react")

            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            axe.default(React, ReactDOM, 1000, config)
        }

        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        setupAxe()
    }

    if (props.isConfError) {
        return (
            <section data-testid="error" className="x-next-plat-mod">
                ERROR!!
            </section>
        )
    }

    const colours = IS_BROWSER() ? (window as any).themeColours[props.themeVersion] : props.themeColours
    const theme = {
        ...nextMaterialUITheme(colours, props.textAlignment || "ltr"),
        colours,
        enablingCenteredContent: props.enablingCenteredContent,
    }
    return (
        <ThemeProvider theme={theme}>
            <section
                className="x-next-plat-mod platform_modernisation_product_summary"
                id={`platform_modernisation_product_summary_${props.itemNumber}`}
            >
                <FeatureSettingsContext.Provider value={props.launchDarklySettings}>
                    <ConnectedProductSummary />
                </FeatureSettingsContext.Provider>
            </section>
        </ThemeProvider>
    )
}

export default App
